import { Static, Type } from '@sinclair/typebox'

export const AdminAccountsSeriesPoint = Type.Object({
    period: Type.String(),
    provisionedAccounts: Type.Number(),
    // Keyed by tier as the indicators table writes it ("smart", "business"),
    // so a new tier shows up without a contract change.
    provisionedAccountsByTier: Type.Record(Type.String(), Type.Number()),
    // Provisioned accounts with a production flow run or an MCP call over the
    // last 30 days — the definition the Metabase questions use.
    activeAccounts: Type.Number(),
    // Provisioned accounts with an MCP call over the last 30 days: executions
    // alone cannot tell one heavy tenant from broad adoption.
    mcpAccounts: Type.Number(),
    totalEnabledFlows: Type.Number(),
    // Month-to-date on the current period, complete on the closed ones.
    totalTasks: Type.Number(),
    totalMcpExecutions: Type.Number(),
})

export type AdminAccountsSeriesPoint = Static<typeof AdminAccountsSeriesPoint>

// The indicators table only covers tenants linked to a Corp customer with a
// known tier — never the whole platform — and Kizeo's own tenants are left out.
// The UI must show this count so the numbers are not read as a platform total.
export const AdminAccountsCoverage = Type.Object({
    tenantsInTable: Type.Number(),
    lastComputedAt: Type.Union([Type.String(), Type.Null()]),
})

export type AdminAccountsCoverage = Static<typeof AdminAccountsCoverage>

export const AdminAccountsOverview = Type.Object({
    periods: Type.Array(Type.String()),
    series: Type.Array(AdminAccountsSeriesPoint),
    coverage: AdminAccountsCoverage,
})

export type AdminAccountsOverview = Static<typeof AdminAccountsOverview>
